import { makeAutoObservable, observable } from 'mobx';
import { IPerformanceOptions } from '../../hooks/apis/use-reports-list';
import { AdvertiserCrudStore } from './advertiser-crud.store';
import { PerformanceResponse } from '../../models/performance.model';
import { SettingsStore } from '@monorepo/controlled/src/stores/settings.store';
import { TableStore } from '@monorepo/controlled/src/stores/table.store';
import { FilterStore, FiltersMap } from '@monorepo/controlled/src/stores/filter.store';
import { advertiserFilterPrototypes, filterPrototypesByProp } from '../../components/filters-menu/filters';
import { Statuses } from '../../enums/status';
import { StringActions } from '@monorepo/tools/src/lib/utils/string';
import { FilterModel } from '@monorepo/controlled/src/models/filter.model';
import { HttpStore } from '@monorepo/controlled/src/stores/http.store';
import { PerformanceApi } from '../../apis/performance.api';

export enum AdvertiserFiltersStoreKeys {
	Advertisers = 'advertisers',
}

export class AdvertiserStore {
	crud = new AdvertiserCrudStore();
	list = new HttpStore<IPerformanceOptions, PerformanceResponse>({
		httpFunc: PerformanceApi.performance,
		model: PerformanceResponse,
	});

	metrics = new HttpStore<IPerformanceOptions, PerformanceResponse>({
		httpFunc: PerformanceApi.performance,
		model: PerformanceResponse,
	});

	settingsStore: SettingsStore;

	// performance = new PerformanceStore<AdvertiserModel>({
	// 	keys: new Set([PerformancesColumnsSnakeCase.AdvertiserId]),
	// });

	constructor(settingsStore: SettingsStore) {
		makeAutoObservable(this, {
			crud: observable,
			list: observable,
			// performance: observable,
		});
		this.settingsStore = settingsStore;
		this.createDefaultFilters();
	}

	createDefaultFilters() {
		const prototype = advertiserFilterPrototypes.find(filter => filter.MenuComponent === 'Status');
		let defaultFilters: FiltersMap;
		if (prototype) {
			defaultFilters = new Map([
				[
					1,
					new FilterModel({
						index: 1,
						label: `Status is ${Statuses.Active}`,
						action: StringActions.Equals,
						value: [Statuses.Active],
						prototype,
					}),
				],
			]);
		}

		Object.values(AdvertiserFiltersStoreKeys).map((key: AdvertiserFiltersStoreKeys) => {
			if (!this.settingsStore.getPages().get(key)) {
				this.settingsStore.getPages().set(key, { tableStore: new TableStore() });
			}
			const advertiserFilterByKey = new FilterStore({
				key,
				currentFilters: defaultFilters,
				filterPrototypesByProp,
			});
			this.settingsStore.getPages().get(key)?.tableStore.setFiltersStore(key, advertiserFilterByKey);
		});
	}

	getListStore() {
		return this.list;
	}

	getCrud() {
		return this.crud;
	}

	getMetrics() {
		return this.metrics;
	}

	// getPerformance() {
	// 	return this.performance;
	// }
}
